import { Center, Loader, Stack, Text } from '@mantine/core'

type Props = {
  label?: string
  minHeight?: number | string
}

/** Центрированный лоадер на странице или в большой панели */
export function PageCenterLoader({
  label = 'Загрузка…',
  minHeight = 240,
}: Props) {
  return (
    <Center mih={minHeight}>
      <Stack align="center" gap="md">
        <Loader size="md" type="oval" />
        <Text size="sm" c="dimmed">
          {label}
        </Text>
      </Stack>
    </Center>
  )
}
